require("./hireCardMetallicStep4.scss");

// @ vendors
const PropTypes = require("prop-types");
const React = require("react");

// @ helpers
const { FormattedText } = require("core/i18n").i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLastNChars } = require('utilities/stringHelper');

// @constants
const {
    SECOND_STEP,
    HYPHEN
} = require('constants/index');

const HireCardMetallicStep4SummaryWithoutValidation = (props) => {
    const {
        immAccounts,
        immHireCardNameSelector,
        immHireCardMetallic,
        immShippingAddress,
        originCountry,
    } = props;
    const selectedAccount = immHireCardMetallic.getIn([
        "steps",
        SECOND_STEP,
        "accountId",
    ]);
    const immAccount = immAccounts.getIn(["byId", selectedAccount]);
    const accountIban = getLastNChars(immAccount.get("iban"));
    const addressValue = immShippingAddress.get("isFetching")
        ? HYPHEN
        : PersonalDataHelper.getHireFormattedShippingAddress(
              immShippingAddress,
              originCountry
          );

    return (
        <div className="hire-card-metallic-step-four__summary row">
            <div className="col-xs-3 print-label">
                <div className="hire-card-metallic-step-four__summary-label">
                    <FormattedText value="hireCardMetallic-summarySelectedName" />
                </div>
                <div className="hire-card-metallic-step-four__summary-value">
                    {immHireCardNameSelector.getIn([
                        "names",
                        immHireCardNameSelector.get("selectedIndex"),
                    ])}
                </div>
            </div>
            <div className="col-xs-4">
                <div className="hire-card-metallic-step-four__summary-label">
                    <FormattedText value="hireCardMetallic-summarySelectedAccount" />
                </div>
                <div className="hire-card-metallic-step-four__summary-value">
                    <span>{immAccount.get("alias")}</span>
                    &nbsp;
                    <span>{accountIban}</span>
                </div>
            </div>
            <div className="col-xs-5 print-label">
                <div className="hire-card-metallic-step-four__summary-label">
                    <FormattedText value="hireCardMetallic-summaryShippingAddress" />
                </div>
                <div className="hire-card-metallic-step-four__summary-value">
                    {addressValue}
                </div>
            </div>
        </div>
    );
};

HireCardMetallicStep4SummaryWithoutValidation.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardMetallic: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    originCountry: PropTypes.string.isRequired,
};

module.exports = HireCardMetallicStep4SummaryWithoutValidation;
